module.exports = __webpack_public_path__ + "img/option-modal-switch-icon.235ca675.svg";